import React, { FunctionComponent, PropsWithChildren } from "react";
import { useEnabledFeatureFlag } from "./FeatureFlagProvider";

type FeatureFlagProps = {
  featureName: string;
};

const FeatureFlagProtectedComponent: FunctionComponent<
  PropsWithChildren<FeatureFlagProps>
> = ({ featureName, children }) => {
  const isFeatureEnabled = useEnabledFeatureFlag(featureName);
  return isFeatureEnabled ? (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>{children}</>
  ) : (
    <div />
  );
};

export default FeatureFlagProtectedComponent;
